export const ACTION_TYPES = {
    CLEAN_EMPLOYEES_LIST_ERROR: 'CLEAN_EMPLOYEES_LIST_ERROR',
    CLEAN_EMPLOYEES_LIST: 'CLEAN_EMPLOYEES_LIST',

    LOAD_EMPLOYEES_LIST_REQUEST: 'LOAD_EMPLOYEES_LIST_REQUEST',
    LOAD_EMPLOYEES_LIST_SUCCESS: 'LOAD_EMPLOYEES_LIST_SUCCESS',
    LOAD_EMPLOYEES_LIST_FAILURE: 'LOAD_EMPLOYEES_LIST_FAILURE'
};